<template>
  <div>
    <div class="chain">
      <i class="chain-item"></i>
      <i class="chain-item"></i>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.chain {
  margin: -40px 0 0;
  box-sizing: border-box;
  display: flex;
  padding: 0 100px 0;
  justify-content: space-between;
}
.chain-item {
  width: 12px;
  height: 80px;
  background-image: linear-gradient(#ec6221, #fff, #ec6221);
  transform-style: preserve-3d;
  border-radius: 6px;
}
.chain-item:before {
  content: "";
  display: block;
  padding: 12px 12px 12px;
  background-color: #ec6221;
  border-radius: 50%;
  transform: translateZ(-1px) translateX(-6px) translateY(-6px);
}
.chain-item:after {
  content: "";
  display: block;
  padding: 12px 12px 12px;
  background-color: #ec6221;
  border-radius: 50%;
  transform: translateZ(-1px) translateX(-6px) translateY(46px);
}
</style>
